import {put} from "@redux-saga/core/effects";
import * as actions from "./referralClientsActions";
import * as systemActions from "../system/systemActions";
import axios from "axios";

export function* referralClientsLoadSaga(action) {
    let config = {
        headers: {
            Authorization: "Bearer " + action.token,
            Accept: "application/json"
        }
    };

    try {
        const response = yield axios.get(
            "/v1/referralClients?startDate=" + action.start + "&endDate=" + action.end,
            config
        );
        yield put(actions.referralClientsLoaded(response.data.result));

    } catch (error) {

    }
}

